import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AngularDeviceInformationService } from 'angular-device-information';

import { AppRoutingModule, routingComponents } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatSliderModule } from '@angular/material/slider';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTabsModule } from '@angular/material/tabs';
import { MatListModule } from '@angular/material/list';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { MatGridListModule } from '@angular/material/grid-list';
import { TopNavComponent } from './top-nav/top-nav.component';
import { SideNavComponent } from './side-nav/side-nav.component';
import { MyVehicleModule } from './my-vehicle/my-vehicle.module';
import { StepCompletionStatusComponent } from './step-completion-status/step-completion-status.component';
import { PaymentOptionsComponent } from './payment/payment-options/payment-options.component';
import { MatMenuModule } from '@angular/material/menu';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatCardModule } from '@angular/material/card';
import { RemoveCardConfirmationComponent } from './payment/payment-options/remove-card-confirmation/remove-card-confirmation.component';
import { AddNewPaymentOptionComponent } from './payment/payment-options/add-new-payment-option/add-new-payment-option.component';
import { ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { AccountBillingHostoryComponent } from './payment/account-billing-hostory/account-billing-hostory.component';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { AdvancedFilterationOptionsComponent } from './payment/account-billing-hostory/advanced-filteration-options/advanced-filteration-options.component';
import { MatDividerModule } from '@angular/material/divider';
import { SharedModule } from './shared/shared.module';
import { PaymentRoutingModule } from './payment/payment-routing/payment-routing.module';
import { AppMainComponentComponent } from './app-main-component/app-main-component.component';
import { AppSubComponentComponent } from './app-sub-component/app-sub-component.component';
import { ResetPinComponentComponent } from './app-sub-component/reset-pin-component/reset-pin-component.component';
import { ResetPinSuccessComponent } from './app-sub-component/reset-pin-success/reset-pin-success.component';
import { WebviewsComponent } from './webviews/webviews.component';
import { MyWehiclesWebViewComponent } from './webviews/my-wehicles-web-view/my-wehicles-web-view.component';
import { MyWehicleTrialsWebViewComponent } from './webviews/my-wehicles-web-view/my-wehicle-trials-web-view/my-wehicle-trials-web-view.component';
import { MyWehicleSubscriptionWebViewComponent } from './webviews/my-wehicles-web-view/my-wehicle-subscription-web-view/my-wehicle-subscription-web-view.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { ContactInfoWebViewComponent } from './webviews/my-wehicles-web-view/contact-info-web-view/contact-info-web-view.component';
import { WebviewsModule } from './webviews/webviews-routing/webviews.module';
import { PurchaseSubscriptionWebviewComponent } from './webviews/my-wehicles-web-view/purchase-subscription-webview/purchase-subscription-webview.component';
import { DataService } from './core/services/data.service';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { QRCodeComponent  } from 'angularx-qrcode'; 

import { LoaderInterceptor } from './core/Interceptors/loader.interceptor';
import { BillingHistoryWebviewComponent } from './webviews/my-wehicles-web-view/billing-history-web-view/billing-history-web-view.component';
import { MatRadioModule } from '@angular/material/radio';
//gdo
import { GdoDesktopComponent } from './gdo/gdo-desktop/gdo-desktop.component';
import { GdoSharedComponent } from './gdo/gdo-shared/gdo-shared.component';
import { GdoDesktopModule } from './gdo/gdo-desktop/gdo-desktop.module';
import { GdoSharedModule } from './gdo/gdo-shared/gdo-shared.module';
import { GdoWebviewComponent } from './gdo/gdo-webview/gdo-webview.component';
import { GdoWebviewModule } from './gdo/gdo-webview/gdo-webview.module';
import { BillingCardsComponent } from './webviews/my-wehicles-web-view/billing-history-web-view/billing-cards/billing-cards.component';
import { PaymentWebViewRoutingModule } from './webviews/payment-webview/payment-web-view-routing.module';
import { PaymentWebViewComponent } from './webviews/payment-webview/payment-web-view.component';
import { PaymentComponent } from './payment/payment.component';
import { WebapymentSHowAllCards } from './payment/payment-options/show-all-cards/web-show-all-cards.component';
import { CardInformationComponent } from './payment/payment-options/card-information/card-information.component';
import { WebPymentCardsDetails } from './payment/payment-options/card-information/card-details/card-details.component';
import { PaymentAddNewCardComponent } from './payment/payment-options/payment-add-new-card/payment-add-new-card.component';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatSelectModule} from '@angular/material/select';
import {FormsModule} from '@angular/forms';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { IviMy23BaseComponent } from './ivi-my23/ivi-my23-base/ivi-my23-base.component';
import { IviAcuraViewComponent } from './ivi-my23/ivi-acura-view/ivi-acura-view.component';
import { IviHondaViewComponent } from './ivi-my23/ivi-honda-view/ivi-honda-view.component';
import { IviMy23EnrollErrorScreenComponent } from './ivi-my23/ivi-my23-enroll-error-screen/ivi-my23-enroll-error-screen.component';
import { IviMy23RenewErrorScreenComponent } from './ivi-my23/ivi-my23-renew-error-screen/ivi-my23-renew-error-screen.component';

// IVI Digital Store MY26
import { IviModule } from './ivi/ivi.module';
import { QrEnrollmentComponent } from './shared/qr-enrollment/qr-enrollment.component';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';


@NgModule({
  declarations: [
    AppComponent,
    routingComponents,
    TopNavComponent,
    SideNavComponent,
    StepCompletionStatusComponent,
    PaymentOptionsComponent,
    RemoveCardConfirmationComponent,
    AddNewPaymentOptionComponent,
    AccountBillingHostoryComponent,
    AdvancedFilterationOptionsComponent,
    AppMainComponentComponent,
    AppSubComponentComponent,
    ResetPinComponentComponent,
    ResetPinSuccessComponent,
    WebviewsComponent,
    MyWehiclesWebViewComponent,
    MyWehicleTrialsWebViewComponent,
    MyWehicleSubscriptionWebViewComponent,
    ContactInfoWebViewComponent,
    PurchaseSubscriptionWebviewComponent,
    BillingHistoryWebviewComponent,
    BillingCardsComponent,
    //GDO
    // incase of gdo component:
    // Any declarations below 'GdoProductComponent' this should be moved to gdo
    GdoDesktopComponent,
    GdoSharedComponent,
    GdoWebviewComponent,
    PaymentWebViewComponent,
    PaymentComponent, 
    WebapymentSHowAllCards,    
    CardInformationComponent,
    WebPymentCardsDetails,
    PaymentAddNewCardComponent,
    IviMy23BaseComponent,
    IviAcuraViewComponent,
    IviHondaViewComponent,
    IviMy23EnrollErrorScreenComponent,
    IviMy23RenewErrorScreenComponent,
    QrEnrollmentComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatSliderModule,
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
    MatTabsModule,
    MatListModule,
    MatGridListModule,
    MyVehicleModule,
    MatSidenavModule,
    MatDividerModule,
    MatMenuModule,
    FlexLayoutModule,
    MatCardModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatRadioModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatFormFieldModule,
    MatInputModule,
    SharedModule,
    PaymentRoutingModule,
    WebviewsModule,
    MatExpansionModule,
    GdoDesktopModule,
    GdoSharedModule,
    GdoWebviewModule,
    PaymentWebViewRoutingModule,
    MatSlideToggleModule,
    MatSelectModule,
    FormsModule,
    QRCodeComponent,
    IviModule

  ],
  providers: [
    AngularDeviceInformationService,
    MatDatepickerModule,
    DataService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderInterceptor,
      multi: true
    },
    provideHttpClient(withInterceptorsFromDi()),
    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: './assets/i18n/',
        suffix: '.json',
      }),
      fallbackLang: 'en-US',
      lang: 'en-US',
    })
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
